"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RfiSubmittalCommonCapabilities = void 0;
var RfiSubmittalCommonCapabilities;
(function (RfiSubmittalCommonCapabilities) {
    RfiSubmittalCommonCapabilities["CanForward"] = "can_forward";
    RfiSubmittalCommonCapabilities["CanSubmitReviewResponse"] = "can_submit_review_response";
    RfiSubmittalCommonCapabilities["CanSubmitOfficialResponse"] = "can_submit_official_response";
    RfiSubmittalCommonCapabilities["CanClose"] = "can_close";
    RfiSubmittalCommonCapabilities["CanEdit"] = "can_edit";
    RfiSubmittalCommonCapabilities["CanDelete"] = "can_delete";
    RfiSubmittalCommonCapabilities["CanViewHistory"] = "can_view_history";
    RfiSubmittalCommonCapabilities["CanReceive"] = "can_receive";
    RfiSubmittalCommonCapabilities["CanResyncOfficialResponse"] = "can_resync_official_response";
    RfiSubmittalCommonCapabilities["CanDismissSyncError"] = "can_dismiss_sync_error";
    RfiSubmittalCommonCapabilities["CanViewSyncError"] = "can_view_sync_error";
    RfiSubmittalCommonCapabilities["CanReopen"] = "can_reopen";
    RfiSubmittalCommonCapabilities["CanSend"] = "can_send";
})(RfiSubmittalCommonCapabilities = exports.RfiSubmittalCommonCapabilities || (exports.RfiSubmittalCommonCapabilities = {}));
//# sourceMappingURL=RfiSubmittalCommonCapabilities.js.map